<template>
    <span class="body-text" v-html="popUpBodyText"></span>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
@Component({})
export default class changeModePopUp extends Vue {
    @Prop()
    popUpData;

    get popUpBodyText() {
        switch (this.popUpData.selectedRadioButton) {
            case 'Optimized with BatteryLife':
                return this.$t('dashboard.switch_to_mode.optimized_with_battery_life', {
                    i18nFallback:
                        "Switching to <b>'Optimized with BatteryLife'</b> dynamically manages battery charging and discharging to maximize lifespan and prioritize self-consumption.",
                });
            case 'Optimized without BatteryLife':
                return this.$t('dashboard.switch_to_mode.optimized_without_battery_life', {
                    i18nFallback:
                        "Switching to <b>'Optimized without BatteryLife'</b> allows deeper battery cycling without lifespan protection, prioritizing self-consumption.",
                });
            case 'External control':
                return this.$t('dashboard.switch_to_mode.external_control', {
                    i18nFallback:
                        "Switching to <b>'External control'</b> disables automatic control and allows an external system to manage energy flow. Avoid switching to <b>'External control'</b> if you are not on site.",
                });
            case 'Keep batteries charged':
                return this.$t('dashboard.switch_to_mode.keep_batteries_charged', {
                    i18nFallback:
                        "Switching to <b>'Keep Batteries Charged'</b> prioritizes grid power to keep batteries fully charged, minimizing discharge.",
                });
            case 'Inverter Only':
                return this.$t('dashboard.switch_to_mode.inverter_only', {
                    i18nFallback:
                        "Choosing <b> 'Inverter only' </b> enables battery-powered inverting but disables charging. Are you sure you want to proceed?.",
                });
            case 'Charger Only':
                return this.$t('dashboard.switch_to_mode.charger_only', {
                    i18nFallback:
                        "Choosing <b> 'Charger only' </b> enables charging from AC input and solars but disables inverting. AC outputs could still be energized directly from the AC input. Are you sure you want to proceed?.",
                });
            case 'Off':
                return this.$t('dashboard.switch_to_mode.off', {
                    i18nFallback:
                        "Choosing <b> 'off mode' </b> disables both inverting and charging, no power output available. The device is turned off beyond the physical ON/OFF switch state. Are you sure you want to proceed?",
                });
            case 'On':
                return this.$t('dashboard.switch_to_mode.on', {
                    i18nFallback:
                        "Choosing <b> 'On' </b> enables auto mode switching between inverter and charging. Inverter and charger both are on. Are you sure you want to proceed?",
                });
            case 'auto':
                return this.$t('dashboard.switch_to_mode.auto', {
                    i18nFallback:
                        "Changing current mode to  <b> 'auto' </b>. Are you sure you would like to proceed with the change? ",
                });
            case 'scheduled':
                return this.$t('dashboard.switch_to_mode.scheduled', {
                    i18nFallback:
                        "Changing current mode to  <b> 'scheduled' </b>. Are you sure you would like to proceed with the change? ",
                });
            case 'manual':
                return this.$t('dashboard.switch_to_mode.manual', {
                    i18nFallback:
                        "Changing current mode to  <b> 'manual' </b>. Are you sure you would like to proceed with the change? ",
                });
            case 'passthrough':
                return this.$t('dashboard.switch_to_mode.passthrough', {
                    i18nFallback:
                        "Changing current mode to  <b> 'passthrough' </b>. Are you sure you would like to proceed with the change? ",
                });
            default:
                return '';
        }
    }
}
</script>
